



























































import {
    Component,
    Prop,
    Vue,
    Inject,
    Provide,
    Watch
} from "vue-property-decorator";
@Component({
})
export default class HomeTopics extends Vue{
    @Prop(Array) data!:any

    do_forum_click(topic){
       window.location.href = 'https://club.isso.com.cn/Default.aspx?Class=Main&Forum='+topic.forum_id;
    }
    do_topic_click(topic){
       window.open( 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic='+topic.topic_id);
    }

}
